// classNames — tiny cn() helper used across the shell and UI components.
// Filters out falsy values so conditional classes (cond && 'x') collapse cleanly.
export function cn(...args) {
  return args.filter(Boolean).join(' ');
}
